export default __webpack_public_path__ + "static/Quickinstallation_01-c033f199f0a2ff809e8f3e8d5becbddf.webp";